import { FunctionComponent, Fragment, useEffect, useMemo } from 'react';
import { Loader, L12nText, useGameStateSlice, useCoreDispatch, gameStateActions, Drawer } from '@pp/core';
import { BetMapping } from '../../../config/bets';
import { RecentResultsItemType } from '../../../api/recentResults';
import { useMwGameStateSlice } from '../../../store/slices/mwGame/selectors';
import { SpinResult } from '../spinResult';
import styles from './ModalRecentResults.module.css';
import { useRecentResultPercentageFetcher } from '../../../store/apiHooks/useRecentResultPercentageFetcher';
import { RecentResultTypePercentage } from '../../../api/recentResultPercentage';

export interface ModalHistoryProps {
  onClose?: () => void;
}

export const ModalRecentResultsConnected: FunctionComponent<ModalHistoryProps> = ({ onClose }: ModalHistoryProps) => {
  const dispatch = useCoreDispatch();
  const recentResults = useMwGameStateSlice.recentResults();
  const isStatisticsOpen = useGameStateSlice.getOpenedLeftDrawer() === 'recentResults';
  const handleClose = (): void => {
    dispatch(gameStateActions.setOpenLeftDrawer(null));
    onClose?.();
  };

  const recentResultPercentageFetcher = useRecentResultPercentageFetcher();
  useEffect(() => {
    recentResultPercentageFetcher();
  }, [recentResultPercentageFetcher]);

  const recentResultsPercentage = useMwGameStateSlice.recentResultPercentage();
  const checkPerCentageAvailability = useMemo(() => (value: RecentResultTypePercentage | null, item: string) => {
    if (value && value.errorCode === '0' && value.betResultStats) {
      return value.betResultStats[item];
    }
  }, [recentResultsPercentage]);
 
  const renderedBetMappingItems = useMemo(() => {
    return Object.keys(BetMapping).map((item) => (
      <div key={item} className={styles.percentage_item_container}>
        <SpinResult className={styles.item} type={item} isStatModal />
        <div className={styles.percentage_value}>
          {(checkPerCentageAvailability(recentResultsPercentage, item) || '0') + '%'}
        </div>
      </div>
    ));
  }, [BetMapping, recentResultsPercentage, checkPerCentageAvailability]);
 
  const renderedRecentResultsItems = useMemo(() => {
    return recentResults?.history.map((history: RecentResultsItemType, index: number) => (
      <Fragment key={history.gameId}>
        <SpinResult
          id={`stats_${index}`}
          className={styles.item}
          type={history?.gameResult}
          active={index === 0}
          multiplier={recentResults.history[index]?.multiplier}
          isMulti={recentResults.history[index]?.rngSlot == recentResults.history[index]?.gameResult}
          isStatModal
        />
      </Fragment>
    ));
  }, [recentResults]);
 
  return (
    <div className={styles.statsDataHolder}>
      <Drawer open={isStatisticsOpen} title={<L12nText tk="STATISTICS" />} onClose={handleClose}>
        <div className="">
          {!recentResults ? (
            <Loader />
          ) : (
            <div className={styles.ModalRecentResults}>
              <div className={styles.percentage_container}>
                {renderedBetMappingItems}
              </div>
              <div className={styles.separator}></div>
              <div className={styles.recent_results}>
                {renderedRecentResultsItems}
              </div>
            </div>
          )}
        </div>
      </Drawer>
    </div>
  );
};
 
